export const siteUrls: Record<string, string> = {
  local: 'http://localhost:4200/',
  dev: 'https://dban.apps.di.givaudan.com/',
  uat: 'https://uban.apps.di.givaudan.com/',
  uat_in: 'https://uban-in.apps.di.givaudan.com/',
  prod: 'https://www.givaudanperfume.id/',
};
